import './PushNotifications.sass';

import React, { FC, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Header, LottieIcon, ScrollView } from '$uikit';
import { hideModal } from '$navigation/helper';
import { setStorageItem, statReachGoal } from '$utils';
import { useTranslator } from '$hooks';
import { subscribe } from '$services';

export const PushNotifications: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();

  useEffect(() => {
    statReachGoal('push_notify_open');
    setStorageItem('lastNotifyRequestShown', `${Date.now()}`);
  }, []);

  const handleEnable = useCallback(() => {
    statReachGoal('push_notify_pass');
    if (Notification.permission === 'denied') {
      alert(t('notify_denied'));
    } else {
      statReachGoal('push_notify_enable');
      subscribe(dispatch);
    }
    hideModal();
  }, []);

  const handleSkip = useCallback(() => {
    hideModal();
    statReachGoal('push_notify_skip');
  }, []);

  return (
    <>
      <Header showCloseButton backButtonOnClick={handleSkip} isTransparent />
      <ScrollView>
        <div className="PushNotifications">
          <div className="PushNotifications__icon">
            <LottieIcon size={120} name="tg_messages" />
          </div>
          <div className="PushNotifications__title">{t('push_notify_subtitle')}</div>
          <div className="PushNotifications__caption">{t('push_notify_caption')}</div>
          <div className="AdultAuth__features">
            <div className="AdultAuth__feature">{t('push_notify_feature1')}</div>
            <div className="AdultAuth__feature">{t('push_notify_feature2')}</div>
            <div className="AdultAuth__feature">{t('push_notify_feature3')}</div>
          </div>
          <Button onClick={handleEnable} stretched style={{ marginTop: 16 }} flare>
            {t('push_notify_button')}
          </Button>
        </div>
      </ScrollView>
    </>
  );
};
